import gql from 'graphql-tag';

export default gql`
mutation UpdatePersonalizedVariableValues($obj: updatePersonalizedVariableValueInput!) {
  updatePersonalizedVariableValue(object: $obj) {
    client_key
    personalized_variable_set_id
  }
}`;
